import { ProductGroup } from "../@types";
import { productGroupsActions } from "../action-types";

interface IProductGroupsState {
  productGroupForUpdate?: ProductGroup;
  isUpdateProductGroup: boolean;
  productGroupsModalIsOpen: boolean;
  refreshTableProductGroups: boolean;
}

type productGroupsActionType =
  | {
      type: typeof productGroupsActions.PRODUCT_GROUPS_MODAL_STATE;
      payload: boolean;
    }
  | {
      type: typeof productGroupsActions.GET_PRODUCT_GROUP_FOR_UPDATE;
      payload: ProductGroup | undefined;
    }
  | {
      type: typeof productGroupsActions.IS_PRODUCT_GROUP_FOR_UPDATE;
      payload: boolean;
    }
  | {
      type: typeof productGroupsActions.SWITCH_PRODUCT_GROUPS_REFRESH_TABLE;
      payload: boolean;
    };

const INITIAL_STATE: IProductGroupsState = {
  productGroupForUpdate: undefined,
  isUpdateProductGroup: false,
  productGroupsModalIsOpen: false,
  refreshTableProductGroups: false,
};

export default function productGroupsReducer(
  state: IProductGroupsState = INITIAL_STATE,
  action: productGroupsActionType
): IProductGroupsState {
  switch (action.type) {
    case productGroupsActions.PRODUCT_GROUPS_MODAL_STATE:
      return {
        ...state,
        productGroupsModalIsOpen: action.payload,
      };
    case productGroupsActions.GET_PRODUCT_GROUP_FOR_UPDATE:
      return {
        ...state,
        productGroupForUpdate: action.payload,
      };
    case productGroupsActions.IS_PRODUCT_GROUP_FOR_UPDATE:
      return {
        ...state,
        isUpdateProductGroup: action.payload,
      };
    case productGroupsActions.SWITCH_PRODUCT_GROUPS_REFRESH_TABLE:
      return {
        ...state,
        refreshTableProductGroups: action.payload,
      };
    default:
      return state;
  }
}
